/* Source: /home/sidsolaiyappan/skooch_ai/app_root.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import "./styles.css";
import { toggleAiChat, closeAiChat, applySchZoom, _setCoachStep, submitMessageFeedback } from "./app_handlers.js";
import { setStoreAiChatInput, setStoreAiChatError, getStoreAiChatInput, setStoreAiShowHistory, getStoreAiShowHistory, setStoreModalIsEvent, getStoreModalIsEvent, setStoreDrawerTitle, setStoreDrawerCategory, setStoreDrawerDeadline, setStoreDrawerPriority, setStoreDrawerOverride, setStoreModalTitle, setStoreModalCategory, setStoreModalStartTime, setStoreModalEndTime, setStoreModalDeadline, setStoreModalPriority, setStoreWeekOffset, setStoreViewMode, setStoreAuthMode, setStoreOnboardingStep, setStoreLandingPage, setStoreLegalReturnTo, getStoreLegalReturnTo, setStoreAnonDataBannerDismissed, setStorePrefFocusPeak, setStoreSchPrefPeak, setStoreWorkLifeBalance } from "./shared/store.js";
import { deleteRule, addStructuredRule, doSaveProfile, onProfilePrefChange, onProfileRuleFormChange, toggleTheme } from "./shared/profile_handlers.js";
import { addSchTask, removeSchTask, addSchEvent, removeSchEvent, addSchConstraint, onSchFormChange, onSchStateChange } from "./shared/scheduler_form_handlers.js";
import { openSchPopup, saveSchPopupEdits, saveSchPopupFixedEdits } from "./shared/scheduler_popup_handlers.js";
import { navigateTo, viewDayInDashboard, goToScheduler, goToSchedulerWeek, goToLearning } from "./shared/nav_handlers.js";
import { handleLogout } from "./shared/auth_handlers.js";
import { _goToClaimSignup, _openClaimModal } from "./shared/claim_handlers.js";
import { skipOnboarding } from "./shared/onboarding_handlers.js";
import { _exitSandboxForAuth, exitSandbox, enterSandbox, enterSandboxFromLanding } from "./shared/sandbox_lifecycle.js";
import { startQuiz } from "./shared/quiz_persistence.js";
import { closeDrawer, saveDrawer } from "./shared/drawer_handlers.js";
import { closeModal, onModalDayToggle, toggleBreakdown, submitModalOrEvent } from "./shared/modal_handlers.js";
import { markDone, deleteTask, snoozeTask } from "./shared/task_lifecycle.js";
import { onICalFileSelected, onICalRemoveCalendar } from "./shared/ical_handlers.js";
import { schCatColor, dayListLabel, taskCategoryLabel, mergeContiguousChunks } from "./shared/scheduler_helpers.js";
import { placeSchTask, acceptScheduledTask, rejectScheduledTask, deleteTaskAndPlacements, orderedSchTasks, applySuggestionAndOptimize, closeSchPopup, removeSchPopupBlock, setSchPref, toggleOverflowDetails, schTasksSidebarCount, removeSchConstraint } from "./scheduler/scheduler_actions.js";
import { runOptimize } from "./scheduler/scheduler_optimize.js";
import { runRandomize, runStressTest } from "./scheduler/sandbox_scenarios.js";
import { MobileDemoTour } from "./scheduler/mobile_demo_tour.js";
import { executeAiAcceptAllPlacements, confirmAiPlan, rejectAiPlan, acceptTimeSuggestion } from "./chat/chat_actions.js";
import { startNewChat, loadChat, deleteSavedChat } from "./chat/chat_session.js";
import { sendAiChatMessage } from "./chat/chat_send.js";
import { dispatchProactiveAction } from "./shared/proactive_handlers.js";
import { sandboxPreset } from "./shared/sandbox_lifecycle.js";
import { DashboardView } from "./dashboard/dashboard.js";
import { LandingView } from "./auth/landing_view.js";
import { LandingViewNew } from "./auth/landing_view_new.js";
import { AuthView } from "./auth/auth_view.js";
import { OnboardingView } from "./auth/onboarding_view.js";
import { PrivacyView } from "./auth/privacy_view.js";
import { TermsView } from "./auth/terms_view.js";
import { ProfileView } from "./profile/profile_view.js";
import { SchedulerView } from "./scheduler/scheduler_view.js";
import { LearningDashboardView } from "./shared/learning_dashboard.js";
import { CoachMarkOverlay } from "./scheduler/coach_mark_overlay.js";
import { NavBar } from "./shared/nav_bar.js";
import { MobileTabBar } from "./shared/mobile_tab_bar.js";
import { AppBanners } from "./shared/app_banners.js";
import { OfflineBanner } from "./shared/offline_banner.js";
import { MaintenanceGate } from "./shared/maintenance_gate.js";
import { TaskModal } from "./shared/task_modal.js";
import { TaskDrawer } from "./shared/task_drawer.js";
import { ToastPrompt } from "./shared/toast_prompt.js";
import { AiChatPanel } from "./shared/ai_chat_panel.js";
import { ICalImportModal } from "./shared/ical_import_modal.js";
import { useStoreSlice, getStoreCurrentPage, subscribeStoreCurrentPage, getStoreViewMode, subscribeStoreViewMode, getStoreUserId, subscribeStoreUserId, getStoreIsLoggedIn, subscribeStoreIsLoggedIn, getStoreIsAnonymous, subscribeStoreIsAnonymous, getStoreProfileLoaded, subscribeStoreProfileLoaded, getStoreClaimPending, subscribeStoreClaimPending, getStoreAccountClaimed, subscribeStoreAccountClaimed, getStoreAnonDataBannerDismissed, subscribeStoreAnonDataBannerDismissed, getStoreSchDevScenarioActive, subscribeStoreSchDevScenarioActive, getStoreCoachMarkStep, subscribeStoreCoachMarkStep, getStoreWeekOffset, subscribeStoreWeekOffset, getStoreFixedBlocks, subscribeStoreFixedBlocks, getStoreGcalSyncing, subscribeStoreGcalSyncing, getStoreIsMobileViewport, getStoreDemoTourActive, subscribeStoreDemoTourActive, setStoreDemoTourActive, getStoreSaveErrorNotice, subscribeStoreSaveErrorNotice, setStoreSaveErrorNotice } from "./shared/store.js";
import { computeWeekInfo } from "./shared/week_dates.js";
import { schedulerFixedEvents, dedupeFixedBlocks } from "./shared/fixed_event_helpers.js";
import { isDevXray } from "./shared/dev_flags.js";
function _legalPushPath(path) {
  try {
    if ((window.location.pathname !== path)) {
      window.history.pushState({}, "", path);
    }
  } catch (__jac_e) {
    if (true) {
      let _lpErr = __jac_e;
    } else {
      throw __jac_e;
    }
  }
}
function bindLegalPopstate() {
  try {
    if (window.__skoochLegalPopstateBound) {
      return;
    }
    window.__skoochLegalPopstateBound = true;
    window.addEventListener("popstate", e => {
      let _pp = String((window.location.pathname || ""));
      if (((_pp === "/privacy") || (_pp === "/privacy-policy"))) {
        setStoreViewMode("privacy");
      } else if (((_pp === "/terms") || (_pp === "/terms-of-service"))) {
        setStoreViewMode("terms");
      } else if (((getStoreViewMode() === "privacy") || (getStoreViewMode() === "terms"))) {
        setStoreViewMode("landing");
      }
    });
  } catch (__jac_e) {
    if (true) {
      let _bpErr = __jac_e;
    } else {
      throw __jac_e;
    }
  }
}
function AppRoot(props) {
  const {themeDark, profileComplete, _coachTutorialEnabled, _currentPrefsSnapshot, toggleCoachTutorial} = props;
  let currentPage = useStoreSlice(getStoreCurrentPage, subscribeStoreCurrentPage);
  let viewMode = useStoreSlice(getStoreViewMode, subscribeStoreViewMode);
  let userId = useStoreSlice(getStoreUserId, subscribeStoreUserId);
  let isLoggedIn = useStoreSlice(getStoreIsLoggedIn, subscribeStoreIsLoggedIn);
  let isAnonymous = useStoreSlice(getStoreIsAnonymous, subscribeStoreIsAnonymous);
  let profileLoaded = useStoreSlice(getStoreProfileLoaded, subscribeStoreProfileLoaded);
  let claimPending = useStoreSlice(getStoreClaimPending, subscribeStoreClaimPending);
  let accountClaimed = useStoreSlice(getStoreAccountClaimed, subscribeStoreAccountClaimed);
  let anonDataBannerDismissed = useStoreSlice(getStoreAnonDataBannerDismissed, subscribeStoreAnonDataBannerDismissed);
  let schDevScenarioActive = useStoreSlice(getStoreSchDevScenarioActive, subscribeStoreSchDevScenarioActive);
  let coachMarkStep = useStoreSlice(getStoreCoachMarkStep, subscribeStoreCoachMarkStep);
  let weekOffset = useStoreSlice(getStoreWeekOffset, subscribeStoreWeekOffset);
  let fixedBlocks = useStoreSlice(getStoreFixedBlocks, subscribeStoreFixedBlocks);
  let gcalSyncing = useStoreSlice(getStoreGcalSyncing, subscribeStoreGcalSyncing);
  let demoTourActive = useStoreSlice(getStoreDemoTourActive, subscribeStoreDemoTourActive);
  let saveErrorNotice = useStoreSlice(getStoreSaveErrorNotice, subscribeStoreSaveErrorNotice);
  let _wk = computeWeekInfo(weekOffset);
  let _weekLabel = _wk["weekLabel"];
  let _dayDates = _wk["dayDates"];
  let _weekIsoDays = _wk["weekIsoDays"];
  let _dayNames = _wk["dayNames"];
  let _isCurrentWeek = _wk["isCurrentWeek"];
  let _todayIdx = _wk["todayIdx"];
  let schFixedEventRows = schedulerFixedEvents(dedupeFixedBlocks(fixedBlocks), _weekIsoDays);
  window.__skoochDevActive = schDevScenarioActive;
  window.__skoochCoachStep = coachMarkStep;
  window.__skoochWeekOffset = weekOffset;
  window.__skoochWeekIsoDays = _weekIsoDays;
  window.__skoochWeekLabel = _weekLabel;
  window.__skoochCurrentPage = currentPage;
  let _maintenanceGated = false;
  try {
    if ((((window.__skoochMaintenanceGate && (viewMode === "app")) && isLoggedIn) && !schDevScenarioActive)) {
      _maintenanceGated = true;
    }
  } catch (__jac_e) {
    if (true) {
      let _mgErr = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  let _newLanding = false;
  try {
    if (window.__skoochNewLanding) {
      _newLanding = true;
    }
  } catch (__jac_e) {
    if (true) {
      let _nlErr = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  let appPageView = null;
  if ((currentPage === "dashboard")) {
    appPageView = __jacJsx(DashboardView, {}, []);
  } else if ((currentPage === "profile")) {
    appPageView = __jacJsx(ProfileView, {"coachTutorialEnabled": _coachTutorialEnabled, "insights": [], "callbacks": {"onPrefChange": onProfilePrefChange, "onSave": () => {
      doSaveProfile(_currentPrefsSnapshot());
    }, "onDeleteRule": deleteRule, "onAddRule": addStructuredRule, "onRuleFormChange": onProfileRuleFormChange, "onToggleTheme": toggleTheme, "onToggleCoachTutorial": () => {
      toggleCoachTutorial();
    }}}, []);
  } else if ((currentPage === "scheduler")) {
    appPageView = __jacJsx(SchedulerView, {"schState": {"schFixedEventRows": schFixedEventRows, "profileComplete": profileComplete}, "weekInfo": {"_dayDates": _dayDates, "_dayNames": _dayNames, "_isCurrentWeek": _isCurrentWeek, "_todayIdx": _todayIdx, "_weekLabel": _weekLabel, "_weekIsoDays": _weekIsoDays}, "callbacks": {"setSchPref": setSchPref, "applySchZoom": z => {
      applySchZoom(z);
    }, "addSchTask": () => {
      addSchTask();
    }, "removeSchTask": removeSchTask, "addSchEvent": () => {
      addSchEvent();
    }, "removeSchEvent": removeSchEvent, "addSchConstraint": addSchConstraint, "removeSchConstraint": removeSchConstraint, "openSchPopup": openSchPopup, "closeSchPopup": closeSchPopup, "saveSchPopupEdits": () => {
      saveSchPopupEdits();
    }, "saveSchPopupFixedEdits": () => {
      saveSchPopupFixedEdits();
    }, "removeSchPopupBlock": () => {
      removeSchPopupBlock();
    }, "runOptimize": () => {
      runOptimize();
    }, "runRandomize": () => {
      runRandomize();
    }, "runStressTest": runStressTest, "applySuggestion": sg => {
      applySuggestionAndOptimize(sg);
    }, "viewDayInDashboard": viewDayInDashboard, "orderedSchTasks": orderedSchTasks, "schTasksSidebarCount": schTasksSidebarCount, "toggleOverflowDetails": toggleOverflowDetails, "taskCategoryLabel": taskCategoryLabel, "dayListLabel": dayListLabel, "mergeContiguousChunks": mergeContiguousChunks, "schCatColor": schCatColor, "onPrevWeek": _ignored => {
      goToSchedulerWeek((weekOffset - 1));
    }, "onNextWeek": _ignored => {
      goToSchedulerWeek((weekOffset + 1));
    }, "onFormChange": onSchFormChange, "onStateChange": onSchStateChange, "placeSchTask": placeSchTask, "acceptScheduledTask": acceptScheduledTask, "rejectScheduledTask": rejectScheduledTask, "deleteTaskAndPlacements": deleteTaskAndPlacements, "acceptAllPlacements": () => {
      executeAiAcceptAllPlacements();
    }, "exitSandbox": () => {
      if (userId) {
        exitSandbox();
      } else {
        _exitSandboxForAuth();
        setStoreViewMode("landing");
        setStoreLandingPage("home");
      }
    }, "onContinueAsGuest": ((isLoggedIn && !isAnonymous) ? null : skipOnboarding), "onFinishProfile": () => {
      setStoreViewMode("quiz");
      setStoreOnboardingStep(0);
    }}}, []);
  } else if ((currentPage === "learning")) {
    if (isDevXray()) {
      appPageView = __jacJsx(LearningDashboardView, {}, []);
    } else {
      appPageView = __jacJsx(DashboardView, {}, []);
    }
  }
  let _xrayActive = false;
  try {
    let _xrayPages = ["dashboard", "scheduler"];
    if ((window.__skoochXray && _xrayPages.includes(currentPage))) {
      _xrayActive = true;
    }
  } catch (__jac_e) {
    if (true) {
      let _xrErr = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  let aiChatPanelView = __jacJsx(AiChatPanel, {"callbacks": {"onToggle": () => {
    toggleAiChat();
  }, "onClose": () => {
    closeAiChat();
  }, "onInputChange": v => {
    setStoreAiChatInput(v);
    setStoreAiChatError("");
  }, "onSend": () => {
    sendAiChatMessage(getStoreAiChatInput());
  }, "onSuggestion": v => {
    sendAiChatMessage(v);
  }, "onConfirmPlan": () => {
    confirmAiPlan();
  }, "onRejectPlan": () => {
    rejectAiPlan();
  }, "onAcceptTimeSuggestion": s => {
    acceptTimeSuggestion(s);
  }, "onNewChat": () => {
    startNewChat();
  }, "onLoadChat": id => {
    loadChat(id).catch(e => {
      console.log("loadChat failed:", e);
    });
  }, "onDeleteChat": id => {
    deleteSavedChat(id);
  }, "onToggleHistory": () => {
    setStoreAiShowHistory(!getStoreAiShowHistory());
  }, "onSandboxPreset": key => {
    sandboxPreset(key);
  }, "onSignUp": () => {
    _exitSandboxForAuth();
    startQuiz();
  }, "onExitSandbox": () => {
    if (userId) {
      exitSandbox();
    } else {
      _exitSandboxForAuth();
      setStoreViewMode("landing");
      setStoreLandingPage("home");
    }
  }, "onFinishProfile": () => {
    startQuiz();
  }, "onProactiveAction": (action, trigger) => {
    dispatchProactiveAction(action, trigger);
  }, "onFeedback": payload => {
    submitMessageFeedback(payload);
  }}}, []);
  let drawerOverlayView = __jacJsx(TaskDrawer, {"callbacks": {"onClose": () => {
    closeDrawer();
  }, "onTitleChange": v => {
    setStoreDrawerTitle(v);
  }, "onCategoryChange": v => {
    setStoreDrawerCategory(v);
  }, "onDeadlineChange": v => {
    setStoreDrawerDeadline(v);
  }, "onPriorityChange": v => {
    setStoreDrawerPriority(v);
  }, "onOverrideChange": v => {
    setStoreDrawerOverride(v);
  }, "onSave": () => {
    saveDrawer();
  }, "onMarkDone": () => {
    markDone();
  }, "onSnooze": () => {
    snoozeTask();
  }, "onDelete": () => {
    deleteTask();
  }}}, []);
  let modalOverlayView = __jacJsx(TaskModal, {"callbacks": {"onClose": () => {
    closeModal();
  }, "onSubmit": () => {
    submitModalOrEvent();
  }, "onToggleIsEvent": () => {
    setStoreModalIsEvent(!getStoreModalIsEvent());
  }, "onToggleBreakdown": () => {
    toggleBreakdown();
  }, "onTitleChange": v => {
    setStoreModalTitle(v);
  }, "onCategoryChange": v => {
    setStoreModalCategory(v);
  }, "onStartTimeChange": v => {
    setStoreModalStartTime(v);
  }, "onEndTimeChange": v => {
    setStoreModalEndTime(v);
  }, "onDeadlineChange": v => {
    setStoreModalDeadline(v);
  }, "onPriorityChange": v => {
    setStoreModalPriority(v);
  }, "onDayToggle": onModalDayToggle}}, []);
  let appBannersView = AppBanners({"gcalSyncing": gcalSyncing, "saveErrorNotice": saveErrorNotice, "profileLoaded": profileLoaded, "profileComplete": profileComplete, "claimPending": claimPending, "currentPage": currentPage, "isAnonymous": isAnonymous, "accountClaimed": accountClaimed, "anonDataBannerDismissed": anonDataBannerDismissed, "callbacks": {"onFinishProfile": () => {
    startQuiz();
  }, "onReenterEmail": () => {
    _goToClaimSignup();
  }, "onSaveAccount": () => {
    _goToClaimSignup();
  }, "onDismissAnonBanner": () => {
    setStoreAnonDataBannerDismissed(true);
    try {
      localStorage.setItem(("skooch_anon_banner_dismissed_" + String(userId)), "1");
    } catch (__jac_e) {
      if (true) {
        let _bdErr = __jac_e;
      } else {
        throw __jac_e;
      }
    }
  }, "onDismissSaveError": () => {
    setStoreSaveErrorNotice("");
  }}});
  let navBarView = __jacJsx(NavBar, {"callbacks": {"onBrandClick": () => {
    if (userId) {
      navigateTo("dashboard");
    } else {
      _exitSandboxForAuth();
      setStoreViewMode("landing");
      setStoreLandingPage("home");
    }
  }, "onNavDashboard": () => {
    navigateTo("dashboard");
  }, "onNavScheduler": () => {
    if (((currentPage === "scheduler") && schDevScenarioActive)) {
      _exitSandboxForAuth();
    }
    goToScheduler();
  }, "onNavProfile": () => {
    navigateTo("profile");
  }, "onNavLearning": () => {
    goToLearning();
  }, "onNavSandbox": () => {
    enterSandbox();
  }, "onSaveAccount": () => {
    _goToClaimSignup();
  }, "onLogout": () => {
    handleLogout();
  }, "onLogin": () => {
    _exitSandboxForAuth();
    setStoreViewMode("auth");
    setStoreAuthMode("login");
  }, "onSignup": () => {
    _exitSandboxForAuth();
    setStoreViewMode("auth");
    setStoreAuthMode("signup");
  }}}, []);
  let mobileTabBarView = __jacJsx(MobileTabBar, {"callbacks": {"onToday": () => {
    closeAiChat();
    navigateTo("dashboard");
  }, "onWeek": () => {
    closeAiChat();
    if (schDevScenarioActive) {
      navigateTo("scheduler");
    } else {
      goToScheduler();
    }
  }, "onChat": () => {
    toggleAiChat();
  }, "onProfile": () => {
    closeAiChat();
    navigateTo("profile");
  }}}, []);
  let demoTourView = null;
  if (demoTourActive) {
    demoTourView = __jacJsx(MobileDemoTour, {"callbacks": {"loadSample": key => {
      if ((key === "light")) {
        runRandomize();
      } else if ((key === "busy")) {
        runStressTest("mild");
      } else {
        runStressTest("impossible");
      }
    }, "optimize": () => {
      runOptimize();
    }, "setFocusPeak": p => {
      setStorePrefFocusPeak(p);
      setStoreSchPrefPeak(p);
    }, "setWlb": v => {
      setStoreWorkLifeBalance(v);
    }, "schCatColor": schCatColor, "weekInfo": {"_dayNames": _dayNames, "_dayDates": _dayDates, "_weekIsoDays": _weekIsoDays}, "onSignUp": () => {
      setStoreDemoTourActive(false);
      _exitSandboxForAuth();
      setStoreLandingPage("home");
      startQuiz();
    }, "onKeepExploring": () => {
      setStoreDemoTourActive(false);
    }}}, []);
  }
  let coachMarkOverlayView = null;
  if (((((coachMarkStep > 0) && (currentPage === "scheduler")) && schDevScenarioActive) && !getStoreIsMobileViewport())) {
    coachMarkOverlayView = __jacJsx(CoachMarkOverlay, {"callbacks": {"onSetFocusPeak": p => {
      setStorePrefFocusPeak(p);
      setStoreSchPrefPeak(p);
    }, "onSetWlb": v => {
      setStoreWorkLifeBalance(v);
    }, "onAdvanceToStep2": () => {
      _setCoachStep(2);
    }, "onSkipTour": () => {
      _setCoachStep(0);
    }, "onDismissForever": () => {
      localStorage.setItem("skooch_coach_dismissed", "1");
      _setCoachStep(0);
    }, "onGoDashboard": () => {
      _setCoachStep(0);
      navigateTo("dashboard");
    }, "onStayInSandbox": () => {
      _setCoachStep(0);
    }, "onSignUpNow": () => {
      _exitSandboxForAuth();
      startQuiz();
    }}}, []);
  }
  return __jacJsx("div", {"className": (themeDark ? "theme-dark" : "theme-light")}, [((viewMode === "loading") ? __jacJsx("div", {"className": "auth-page"}, [__jacJsx("div", {"className": "auth-spinner"}, ["Loading..."])]) : null), (((viewMode === "app") && _maintenanceGated) ? __jacJsx(MaintenanceGate, {}, []) : null), (((viewMode === "app") && !_maintenanceGated) ? __jacJsx("div", {}, [navBarView, __jacJsx(OfflineBanner, {}, []), appBannersView, (_xrayActive ? __jacJsx("div", {"className": "learning-xray-host", "style": {"marginRight": "38vw"}}, [appPageView]) : appPageView), (_xrayActive ? __jacJsx("div", {"className": "learning-xray-pane", "style": {"position": "fixed", "top": "var(--nav-height, 56px)", "right": "0", "bottom": "0", "width": "38vw", "overflowY": "auto", "background": "var(--bg-primary)", "borderLeft": "1px solid var(--border)", "boxShadow": "var(--shadow-lg)", "zIndex": 90}}, [__jacJsx(LearningDashboardView, {}, [])]) : null), aiChatPanelView, __jacJsx(ToastPrompt, {}, []), drawerOverlayView, modalOverlayView, __jacJsx(ICalImportModal, {"callbacks": {"onFileSelected": f => {
    onICalFileSelected(f);
  }, "onRemove": name => {
    onICalRemoveCalendar(name);
  }, "onImportSuccess": () => {
    _openClaimModal("ical-import");
  }}}, []), coachMarkOverlayView, mobileTabBarView, demoTourView]) : null), ((viewMode === "quiz") ? __jacJsx(OnboardingView, {}, []) : null), ((viewMode === "auth") ? __jacJsx(AuthView, {}, []) : null), (((viewMode === "landing") && _newLanding) ? __jacJsx(LandingViewNew, {"callbacks": {"onGetStarted": () => {
    setStoreLandingPage("home");
    startQuiz();
  }, "onLogin": () => {
    setStoreLandingPage("home");
    setStoreViewMode("auth");
    setStoreAuthMode("login");
  }, "onShowHome": () => {
    setStoreLandingPage("home");
  }, "onShowProduct": () => {
    setStoreLandingPage("product");
  }, "onShowPricing": () => {
    setStoreLandingPage("pricing");
  }, "onShowResources": () => {
    setStoreLandingPage("resources");
  }, "onEnterSandbox": () => {
    enterSandboxFromLanding();
  }, "onShowPrivacy": () => {
    setStoreLegalReturnTo("landing");
    _legalPushPath("/privacy");
    setStoreViewMode("privacy");
  }, "onShowTerms": () => {
    setStoreLegalReturnTo("landing");
    _legalPushPath("/terms");
    setStoreViewMode("terms");
  }}}, []) : null), (((viewMode === "landing") && !_newLanding) ? __jacJsx(LandingView, {"callbacks": {"onGetStarted": () => {
    setStoreLandingPage("home");
    startQuiz();
  }, "onLogin": () => {
    setStoreLandingPage("home");
    setStoreViewMode("auth");
    setStoreAuthMode("login");
  }, "onShowHome": () => {
    setStoreLandingPage("home");
  }, "onShowProduct": () => {
    setStoreLandingPage("product");
  }, "onShowPricing": () => {
    setStoreLandingPage("pricing");
  }, "onShowResources": () => {
    setStoreLandingPage("resources");
  }, "onEnterSandbox": () => {
    enterSandboxFromLanding();
  }, "onShowPrivacy": () => {
    setStoreLegalReturnTo("landing");
    _legalPushPath("/privacy");
    setStoreViewMode("privacy");
  }, "onShowTerms": () => {
    setStoreLegalReturnTo("landing");
    _legalPushPath("/terms");
    setStoreViewMode("terms");
  }}}, []) : null), ((viewMode === "privacy") ? PrivacyView({"callbacks": {"onBack": () => {
    _legalPushPath("/");
    setStoreViewMode(getStoreLegalReturnTo());
  }, "onShowTerms": () => {
    _legalPushPath("/terms");
    setStoreViewMode("terms");
  }}}) : null), ((viewMode === "terms") ? TermsView({"callbacks": {"onBack": () => {
    _legalPushPath("/");
    setStoreViewMode(getStoreLegalReturnTo());
  }, "onShowPrivacy": () => {
    _legalPushPath("/privacy");
    setStoreViewMode("privacy");
  }}}) : null)]);
}
export {AppRoot, bindLegalPopstate};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:bindLegalPopstate": {"is_writer": true, "touches": ["*"]}, "func:AppRoot": {"is_writer": true, "touches": ["*"]}}); };
//# sourceMappingURL=app_root.js.map
